/** Allineato al BE FourShop.Domain.Shared.Enums.ProductProjectType */
export enum ProductProjectTypeEnum {
  Subli = 0,
  Evo = 1,
}
